import React, { memo, forwardRef, useRef } from 'react';
import { useDateFieldState } from '@react-stately/datepicker';
import { useDateField } from '@react-aria/datepicker';
import { useLocale } from '@react-aria/i18n';
import { createCalendar } from '@internationalized/date';
import { mergeProps } from '@react-aria/utils';
import { Typography } from '../typography';
import { DateSegment } from './DateSegment';
import { cutTrashProps } from '../../utils';
export const DateInput = memo(forwardRef(function DateInput(props, ref) {
    const { value, defaultValue, onChange, minValue, maxValue, placeholderValue, hideTimeZone, hourCycle, isDisabled, isReadOnly, isRequired, validationState, ...rest } = props;
    const { locale } = useLocale();
    const state = useDateFieldState({
        ...props,
        locale,
        createCalendar,
    });
    const fieldRef = useRef(null);
    const { fieldProps } = useDateField(props, state, fieldRef);
    const finalProps = cutTrashProps(mergeProps(rest, fieldProps));
    return (React.createElement(Typography, { ...finalProps, Component: "div", ref: fieldRef }, state.segments.map((segment, i) => (React.createElement(DateSegment, { ref: i === 0 ? ref : undefined, key: i, segment: segment, state: state })))));
}));
